import Link from 'next/link';
import { AnimatePresence, motion } from 'framer-motion';

import { ContactModal } from '@/shared/components/contact-modal';
import { CrossIcon } from '@/shared/components/icons/cross-icon';
import { Button } from '@/shared/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/shared/components/ui/card';

interface MarketingPopupProps {
  onCloseClick: () => void;
}

export const MarketingPopup = (props: MarketingPopupProps) => {
  const { onCloseClick } = props;

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 z-10 bg-black/50 backdrop-blur-sm"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
      />

      <motion.div
        initial={{ opacity: 0, scale: 0.9, x: '-50%', y: '-50%' }}
        animate={{ opacity: 1, scale: 1, x: '-50%', y: '-50%' }}
        exit={{ opacity: 0, scale: 0.9, x: '-50%', y: '-50%' }}
        transition={{
          type: 'spring',
          damping: 25,
          stiffness: 300,
          delay: 0.1,
        }}
        className="fixed left-1/2 top-1/2 z-20 w-full max-w-[540px]"
      >
        <Card className="relative flex flex-col items-center justify-center bg-neutral-100 dark:bg-zinc-800">
          <Button
            className="absolute right-4 top-4"
            size="icon-xs"
            variant="outline"
            onClick={onCloseClick}
            aria-label="Закрыть рекламный попап"
          >
            <CrossIcon className="h-4 w-4" />
          </Button>

          <CardHeader className="p-4 pb-8 lg:p-6 lg:pb-8">
            <CardTitle className="!mb-2 pt-12 text-center text-lg">
              &#128640;&nbsp;2&nbsp;занятия по&nbsp;цене одного до&nbsp;конца мая&nbsp;&#128640;
            </CardTitle>

            <CardDescription className="text-center text-sm">
              Запишитесь на&nbsp;бесплатную встречу с&nbsp;нашим менеджером&nbsp;&mdash; мы&nbsp;подберем вам план
              занятий и&nbsp;преподавателя
            </CardDescription>
          </CardHeader>

          <CardContent>
            <ContactModal entryPoint="MARKETING_POPUP">
              <Button variant="cta" className="px-6" aria-label="Перейти в телеграм бот школы для прохождения теста">
                Записаться
              </Button>
            </ContactModal>
          </CardContent>
        </Card>
      </motion.div>
    </AnimatePresence>
  );
};
